import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@/shared/api/reauth.api';
import { AppStoreTag } from '@/shared/constants/app-store-tag.constant';

export const boatV2ServiceApi = createApi({
	reducerPath: 'boat v2 service',
	tagTypes: [AppStoreTag.Boat],
	baseQuery: baseQueryWithReauth(`${API_URL}/hdata-boat/api/v2`),
	endpoints: () => ({}),
});
